import router from '@/router';
export default {
  state: {
    entityName: '',
    memberDetail: {},
    couponAvailableList: [],
    couponDetail: {},
    infoGetWeeks: '',
    infoGetTimes: '',
    infoEffectiveConditionLimit: '',
    infoEffectiveDate: '',
    writeSessionId: ''
  },
  getters: {},
  mutations: {
    setMemberDetail(state: any, { member, entityName }: any) {
      state.memberDetail = member;
      state.entityName = entityName;
    },
    // setCouponAvailableList(state: any, { list,total }: any) {
    //     const _list = list.map((item: any) => {
    //         let _item = item;
    //         _item.couponInstanceEffectiveEndTime = router.app.$format(_item.couponInstanceWriteOffTime, 'YYYY.MM.DD');
    //         return _item
    //     });    
    //     state.couponAvailableList = [...state.couponAvailableList, ..._list];
    // },
    setCouponDetail(state: any, params: any) {
      if (params.coupon) {
        params.coupon.couponEffectiveStartTime = router.app.$format(params.coupon.couponEffectiveStartTime, 'YYYY.MM.DD');
        params.coupon.couponEffectiveEndTime = router.app.$format(params.coupon.couponEffectiveEndTime, 'YYYY.MM.DD');
        state.writeSessionId = params.writeSessionId;
        state.couponDetail = params.coupon;
      }


    },
    clearCouponAvailableList(state: any) {
      state.couponAvailableList = [];
    },
    setCouponInfos(state: any, data: any) {
      state.infoGetWeeks =
        data.couponGetTimeLimitSwitch == 0
          ? '不限星期'
          : (data.getTimeLimitWeekList || [])
            .map((item: number) => {
              return ['周一', '周二', '周三', '周四', '周五', '周六', '周日'][item - 1];
            })
            .join(',');
      state.infoGetTimes =
        data.couponGetTimeLimitSwitch == 0
          ? '不限时段'
          : (data.getTimeLimitTimeList || [])
            .map((item: any) => item.startTime + '-' + item.endTime)
            .join(',');
      state.infoEffectiveConditionLimit = [
        '不限金额',
        '消费满' +
        (router.app as any).$currency(Number(data.couponEffectiveConditionPrice).d(100)) +
        '元, 可使用此券',
      ][data.couponEffectiveConditionSwitch];
      state.infoEffectiveDate = [
        [(data.couponEffectiveStartTime || '').replace(/-/g, '.'), (data.couponEffectiveEndTime || '').replace(/-/g, '.')].join('-'),
        data.couponActivedLimitedStartDay == 0 && data.couponActivedLimitedDays == 1
          ? '仅当天有效'
          : (data.couponActivedLimitedStartDay == 0
            ? '领取后当天开始(含当天)有效'
            : '领取后' +
            (data.couponActivedLimitedStartDay + 1 > 0
              ? '第' + (data.couponActivedLimitedStartDay + 1) + '天开始(含当天)有效'
              : '当天开始有效')) +
          ', 有效期' +
          data.couponActivedLimitedDays +
          '天',
        [data.couponGetStartTime, data.couponGetEndTime].join('至'),
      ][data.couponEffectiveSwitch];
    }
  },
  actions: {
    async memberDetail({ commit }: any, params: any) {
      params.entityId = router.app.$global.parentBusinessEntityId ? router.app.$global.parentBusinessEntityId : router.app.$global.tenantId
      params.entityType = router.app.$global.parentBusinessEntityTypeId ? router.app.$global.parentBusinessEntityTypeId : router.app.$global.tenantType
      // params.entityId = router.app.$global.tenantId;
      // params.entityType = router.app.$global.tenantType;
      const { error, success }: any = await router.app.$request('SEARCH_MEMBER_DETAIL', params);
      if (success) {
        commit('setMemberDetail', { ...success.data });
      }
      return { error, success };
    },
    async dispatchCouponAvailableList({ commit }: any, params: any) {
      const { error, success }: any = await router.app.$request('COUPON_AVAILABLE_LIST', params);
      // if (success) {
      //     commit('setCouponAvailableList', { ...success.data });
      // }
      return { error, success };
    },
    async dispatchCouponDetail({ commit }: any, params: any) {
      params.writeOffBusinessEntityId = router.app.$global.tenantId;
      params.writeOffAccountId = router.app.$global.uId
      params.writeOffAccountName = router.app.$global.uName
      params.flowType = 1
      const { error, success }: any = await router.app.$request('COUPON_DETAIL', params);
      if (success) {
        if (success.data) {
          commit('setCouponDetail', success.data);
          if (params.operationType == 0) {
            commit('setCouponInfos', success.data.coupon);
          }

        }

      }
      return { error, success };
    }
  }
}